export interface ResourceFilter {
  search: string;
}

export const createDefaultFilter = (): ResourceFilter => ({
  search: '',
});
